var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { utilTime } from "../../../utils/utilTime";
import { TypeActionBalloonInfo } from "./actionBalloonInfo";
var initial = {
    balloonContentId: undefined,
    balloonLevel: undefined,
    balloonOfferBufferTime: undefined,
    remainingTime: undefined,
};
export var reducerBalloonInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionBalloonInfo.Received && action.balloonInfo != undefined) {
        var _a = action.balloonInfo, balloonContentId = _a.balloonContentId, balloonLevel = _a.balloonLevel, balloonOfferBufferTime = _a.balloonOfferBufferTime, remainingTime = _a.remainingTime;
        return __assign({}, state, { balloonContentId: balloonContentId,
            balloonLevel: balloonLevel, balloonOfferBufferTime: utilTime.remainingTimeToTimestamp((balloonOfferBufferTime || 0) + (remainingTime || 0)), remainingTime: utilTime.remainingTimeToTimestamp(remainingTime) });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/reducerBalloonInfo.ts
// module id = 2532
// module chunks = 3